{
  "title": "Aperçu d'aujourd'hui",
  "portfolios_one": "{{count}} portefeuille",
  "portfolios_other": "{{count}} portefeuilles",
  "aumLabel": "{{value}} Actif sous gestion",
  "marketStatus": {
    "preMarket": "Avant l'ouverture",
    "open": "Marché ouvert",
    "afterHours": "Après la fermeture",
    "closed": "Marché fermé"
  },
  "clickableSnapshotCard": "Carte d'aperçu cliquable",
  "asOfLabel": "En date du {{value}}"
}
